import _ from 'lodash';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleError } from '../../../components/errors/errorHandling';
import { getOrganizationsList } from '../../../services/organization/OrganizationService';
import { setOrganizations } from '../../../slices/organization';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useOrganizationsList = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const dispatch = useDispatch();

  const loadAsync = async () => {
    try {
      const { data } = await getOrganizationsList();
      const orderedData = _.orderBy(data, (organization) => {
        return organization.name;
      });
      dispatch(setOrganizations(orderedData));
    } catch (error) {
      handleError(error);
    }
    setIsLoading(false);
  };

  return {
    getOrganizations: loadAsync,
    isLoading,
  };
};

export default useOrganizationsList;
